import { uniqueId } from "lodash";
import { file as fileUtil } from "./file.util";

export const file = {
  transferFilesBySource(files) {
    return files && files.length
      ? files.map(item => {
          return file.transferFileBySource(item);
        })
      : [];
  },
  // 依據檔案類型（source）轉換對應的參數
  transferFileBySource(file) {
    if (!file) return null;

    const isYT = file.source === "youtube";

    const url = isYT ? `https://img.youtube.com/vi/${file.name}/0.jpg` : file.url;

    return {
      ...file,
      isYT: isYT,
      // 若為 youtube 影片則檔案名稱即 youtbe id
      ytId: isYT ? file.name : null,
      // 依據 youtube id 取得影片縮圖
      url: url,
      thumbUrl: url
    };
  },
  // 轉換圖片裁切器屬性結構至後端上傳檔案結構
  transferCutterImgToUploadFile(file, base64Image) {
    if (!file) return {};

    return {
      uid: file.uid,
      name: file.name,
      url: base64Image,
      isUpload: true,
      source: "gcs"
    };
  },
  // 轉換 youtube 設定屬性結構至後端上傳檔案結構
  transferCutterYTVideoToUploadFile(youtubeId) {
    return {
      uid: uniqueId("yt_video"),
      name: youtubeId,
      url: `https://img.youtube.com/vi/${youtubeId}/0.jpg`,
      isUpload: true,
      isYT: true,
      ytId: youtubeId,
      source: "youtube"
    };
  },
  // 轉換 Antd Upload 屬性結構至後端上傳檔案結構
  async transferAntUploadToUploadFile(file) {
    if (!file) return {};

    const thumbUrl = file.originFileObj ? await fileUtil.getBase64(file.originFileObj) : null;

    return {
      ...file,
      uid: file.uid,
      name: file.name,
      url: thumbUrl,
      isUpload: true,
      source: "gcs"
    };
  },
  // 上傳檔案轉換至 base64 編碼
  getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  },
  // 轉換 base64 編碼至 blob 物件
  async getBlobFromBase64(base64Data) {
    const res = await fetch(base64Data);
    const blob = await res.blob();
    return blob;
  },
  /**
   * 從 ajax 回應物件內取得檔案名稱
   * @param {object} response response object of ajax.
   * @param {boolean} isUriEncode is file name encode by uriencode.
   * @returns 檔案名稱
   */
  getFileNameByResponse(response, isUriEncode = false) {
    const fileName = response.headers
      .get("Content-Disposition")
      .split(";")
      .find(n => n.includes("filename="))
      .replace("filename=", "")
      .replace(/"/g, "")
      .trim();
    return isUriEncode ? decodeURI(fileName) : fileName;
  },
  /**
   * 取得檔案副檔名
   * @param {string} fileName 檔案名稱
   * @returns {string} 檔案副檔名
   */
  getFileExtension(fileName) {
    return fileName.split(".").pop().toLowerCase();
  },
  /**
   * 判斷檔案是否為圖片
   * @param {string} fileName 檔案名稱
   * @returns {boolean} 是否為圖片
   */
  isImageFile(fileName) {
    const extension = fileUtil.getFileExtension(fileName);
    return ["jpg", "jpeg", "png", "gif"].includes(extension);
  }
};
